import {Component, inject, Input} from '@angular/core'
import {UserService} from '../../../services/user.service'
import {MatProgressBar} from '@angular/material/progress-bar'
import {MatButton} from '@angular/material/button'

@Component({
  selector: 'spb-progress-ng',
  templateUrl: './progress-ng.component.html',
  styleUrl: './progress-ng.component.scss',
  imports: [
    MatProgressBar,
    MatButton
  ]
})
export class ProgressNgComponent {
  @Input() message = 'Vänta...'
  @Input() error = ''
  @Input() errored = false
  /**
   * Default true and then we only show the progress bar
   */
  @Input() minimal = true

  protected service = inject(UserService)
}
